import React from 'react'
import { useAdminFilter } from './AdminFilterContext'
import { InternalCheckbox, InternalToggle } from './AdminLayout.styles'

/**
 * Opt-in toggle (default off) that flips internal-user exclusion off for the whole
 * admin surface via {@link useAdminFilter}. When on, internal users and their
 * cascading data are shown and user/trip rows carry an "Internal" badge (ADR 0002).
 * Sits in the admin nav beside the date range so both global scopes live together.
 */
const InternalDataToggle: React.FC = () => {
	const { includeInternal, setIncludeInternal } = useAdminFilter()

	return (
		<InternalToggle>
			<InternalCheckbox
				aria-label="Show internal data"
				checked={includeInternal}
				onChange={e => setIncludeInternal(e.target.checked)}
			/>
			Show internal data
		</InternalToggle>
	)
}

export default InternalDataToggle
